import * as React from "react";
import { AppStateContext } from "./AppStateProvider";
import Timeout from "./Timeout";
var Errors = function (props) {
    var updateState = React.useContext(AppStateContext).updateState;
    if (props.errors.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "errors", role: "alert", onClick: function () { return updateState({ errors: [] }); }, title: "Dismiss" },
        React.createElement(Timeout, { timeout: 5000, callback: function () { return updateState({ errors: [] }); } }),
        React.createElement("span", { className: "errors-icon", "aria-hidden": "true" }, "\u26A0\uFE0F"),
        React.createElement("div", { className: "errors-body" }, props.errors.map(function (err, idx) { return (React.createElement("p", { key: idx }, err)); }))));
};
export default Errors;
